﻿// @ts-nocheck
// admin: companies + users

function adminBillingStatusColor(status) {
  return {
    draft: "#6b7280",
    sent: "#2563eb",
    paid: "#16a34a",
    failed: "#d97706",
  }[status] || "#6b7280";
}

function adminRenderLatestInvoice(c) {
  const invoice = c.platformLatestInvoice;
  if (!invoice || !invoice.invoiceId) return "";
  const amount = invoice.amountUsd ? `$${Number(invoice.amountUsd).toFixed(2)}` : "";
  const label = invoice.invoiceType === "custom_service" ? "custom invoice" : "plan invoice";
  const when = invoice.paidAt || invoice.sentAt || invoice.failedAt || invoice.updatedAt;
  const date = when ? new Date(when).toLocaleDateString() : "";
  const link = invoice.hostedInvoiceUrl
    ? ` · <a href="${escapeHtml(invoice.hostedInvoiceUrl)}" target="_blank" rel="noopener noreferrer">open</a>`
    : "";
  return `<div class="small-text" style="margin-top:0.2rem;">latest ${label}: <span style="color:${adminBillingStatusColor(invoice.status)};">${escapeHtml(invoice.status)}</span>${amount ? ` · ${escapeHtml(amount)}` : ""}${date ? ` · ${escapeHtml(date)}` : ""}${link}</div>`;
}

function adminRenderCustomServices(c) {
  const services = Array.isArray(c.platformCustomServices) ? c.platformCustomServices : [];
  if (!services.length) return "";
  const recent = services.slice(-3).reverse();
  return `<div style="margin-top:0.35rem; display:flex; gap:0.35rem; flex-wrap:wrap;">${recent.map((service) => {
    const state = service.billingStatus || service.status;
    const amount = `$${Number(service.amountUsd || 0).toFixed(2)}`;
    const cadence = service.interval === "monthly" ? "/mo" : " once";
    return `<span class="small-text" style="display:inline-flex; gap:0.25rem; align-items:center; padding:0.15rem 0.45rem; border:1px solid var(--border-color); border-radius:999px;"><strong>${escapeHtml(service.name)}</strong> ${escapeHtml(amount + cadence)} <span style="color:${adminBillingStatusColor(state)};">${escapeHtml(state)}</span></span>`;
  }).join("")}</div>`;
}

async function adminLoadCompanies() {
  const list = document.getElementById("adminCompaniesList");
  if (!list) return;
  const result = await fetchAdmin("/api/admin/companies");
  if (!result.ok) {
    list.innerHTML = `<p class="small-text" style="color:#dc2626;">${escapeHtml(result.data.error || "Failed to load companies")}</p>`;
    return;
  }

  adminCompaniesCache = result.data.companies || [];
  if (!adminCompaniesCache.length) {
    list.innerHTML = `<p class="small-text">No companies yet.</p>`;
  } else {
    // Aggregate MRR across all active monthly + 1/12 of yearly subscriptions
    let mrr = 0;
    let activeCount = 0;
    let trialCount = 0;
    for (const c of adminCompaniesCache) {
      const s = c.subscription;
      if (!s) continue;
      if (s.status === "active") {
        activeCount++;
        if (s.plan === "monthly" || s.plan === "custom") mrr += s.amountUsd || 0;
        else if (s.plan === "yearly") mrr += (s.amountUsd || 0) / 12;
      } else if (s.status === "trialing") {
        trialCount++;
      }
    }
    const summary = `
      <div style="display:flex; gap:1rem; flex-wrap:wrap; margin-bottom:0.75rem; padding:0.5rem 0.75rem; background:var(--bg-secondary); border:1px solid var(--border-color); border-radius:0.5rem;">
        <div><strong>$${mrr.toFixed(0)}</strong> <span class="small-text">MRR</span></div>
        <div><strong>${activeCount}</strong> <span class="small-text">active</span></div>
        <div><strong>${trialCount}</strong> <span class="small-text">trialing</span></div>
      </div>
    `;
    list.innerHTML = summary + adminCompaniesCache
      .map((c) => {
        const s = c.subscription;
        let subLine = `<span class="small-text">no subscription</span>`;
        if (s) {
          const periodEnd = s.currentPeriodEnd ? new Date(s.currentPeriodEnd).toLocaleDateString() : "—";
          const amount = s.amountUsd ? `$${s.amountUsd}/${s.plan === "yearly" ? "yr" : "mo"}` : "free";
          const statusColor = {
            active: "#16a34a",
            trialing: "#2563eb",
            past_due: "#d97706",
            canceled: "#6b7280",
          }[s.status] || "#6b7280";
          subLine = `<span class="small-text">plan: <strong>${escapeHtml(s.plan)}</strong> · <span style="color:${statusColor};">${escapeHtml(s.status)}</span> · ${escapeHtml(amount)} · renews ${escapeHtml(periodEnd)}</span>`;
        }
        const billingEmailLine = c.platformBillingEmail
          ? `<div class="small-text">billing: ${escapeHtml(c.platformBillingEmail)}</div>`
          : "";
        return `
          <div style="padding:0.5rem; border:1px solid var(--border-color); border-radius:0.5rem; margin-bottom:0.5rem;">
            <div style="font-weight:600;">${escapeHtml(c.displayName)}</div>
            <div class="small-text">${escapeHtml(c.slug)}${c.primaryDomain ? ` · ${escapeHtml(c.primaryDomain)}` : ""}</div>
            <div class="small-text">billing model: ${escapeHtml((c.billingModel === "service_based" ? "service-based" : "hourly"))}</div>
            <div class="small-text">${escapeHtml((c.fromEmails || []).join(", ") || "No from emails")}</div>
            ${billingEmailLine}
            <div style="margin-top:0.25rem;">${subLine}</div>
            ${adminRenderLatestInvoice(c)}
            ${adminRenderCustomServices(c)}
            <div style="margin-top:0.4rem; display:flex; gap:0.4rem; flex-wrap:wrap;">
              <button class="btn btn-secondary btn-sm" onclick="adminEditCompany('${escapeJsSingleQuoted(c.id)}')">Edit</button>
              <button class="btn btn-secondary btn-sm" onclick="adminDeleteCompany('${escapeJsSingleQuoted(c.id)}')">Delete</button>
              ${c.platformStripeSubscriptionId
                ? `<button class="btn btn-secondary btn-sm" onclick="adminBillingPortal('${escapeJsSingleQuoted(c.id)}')">Billing Portal</button>`
                : `<button class="btn btn-secondary btn-sm" onclick="adminBillingStartCheckout('${escapeJsSingleQuoted(c.id)}')">Send Plan Invoice</button>`
              }
              <button class="btn btn-secondary btn-sm" onclick="adminBillingAddCustomService('${escapeJsSingleQuoted(c.id)}')">+ Custom Service</button>
            </div>
          </div>
        `;
      })
      .join("");
  }

  const userCompany = document.getElementById("adminUserCompany");
  if (userCompany) {
    const prev = userCompany.value;
    userCompany.innerHTML = `<option value="">(no company)</option>` + adminCompaniesCache
      .map((c) => `<option value="${escapeHtml(c.id)}">${escapeHtml(c.displayName)}</option>`)
      .join("");
    if (prev) userCompany.value = prev;
  }
}

async function adminLoadUsers() {
  const list = document.getElementById("adminUsersList");
  if (!list) return;
  const result = await fetchAdmin("/api/admin/users");
  if (!result.ok) {
    list.innerHTML = `<p class="small-text" style="color:#dc2626;">${escapeHtml(result.data.error || "Failed to load users")}</p>`;
    return;
  }

  const companiesById = Object.fromEntries(adminCompaniesCache.map((c) => [c.id, c]));
  const users = result.data.users || [];
  if (!users.length) {
    list.innerHTML = `<p class="small-text">No users yet.</p>`;
    return;
  }

  list.innerHTML = users
    .map((u) => {
      const companyName = u.companyId ? companiesById[u.companyId]?.displayName || "Unknown" : "None";
      return `
        <div style="padding:0.5rem; border:1px solid var(--border-color); border-radius:0.5rem; margin-bottom:0.5rem;">
          <div style="font-weight:600;">${escapeHtml(u.email)}</div>
          <div class="small-text">role: ${escapeHtml(u.role)}${u.disabled ? " · disabled" : ""}</div>
          <div class="small-text">company: ${escapeHtml(companyName)}</div>
          <div style="margin-top:0.4rem; display:flex; gap:0.4rem; flex-wrap:wrap;">
            <button class="btn btn-secondary btn-sm" onclick="adminEditUser('${escapeJsSingleQuoted(u.id)}')">Edit</button>
            <button class="btn btn-secondary btn-sm" onclick="adminResetPassword('${escapeJsSingleQuoted(u.email)}')">Reset PW</button>
            <button class="btn btn-secondary btn-sm" onclick="adminToggleDisable('${escapeJsSingleQuoted(u.id)}', ${u.disabled ? "false" : "true"})">${u.disabled ? "Enable" : "Disable"}</button>
            <button class="btn btn-secondary btn-sm" onclick="adminRemoveCompany('${escapeJsSingleQuoted(u.id)}')">Remove Company</button>
            <button class="btn btn-danger btn-sm" onclick="adminDeleteUser('${escapeJsSingleQuoted(u.id)}')">Delete</button>
          </div>
        </div>
      `;
    })
    .join("");
}

async function adminInitPanel() {
  const panel = document.getElementById("adminPanel");
  const adminTabBtn = document.getElementById("adminTabBtn");
  if (!panel) return;
  if (!isAdminUser()) {
    panel.style.display = "none";
    if (adminTabBtn) adminTabBtn.style.display = "none";
    if (currentView === "admin") {
      switchTab("dashboard");
    }
    return;
  }
  panel.style.display = "";
  if (adminTabBtn) adminTabBtn.style.display = "";
  await adminLoadCompanies();
  await adminLoadUsers();
}

async function adminAddCompany() {
  adminSetStatus("adminCoStatus", "");
  const slug = document.getElementById("adminCoSlug").value.trim();
  const displayName = document.getElementById("adminCoName").value.trim();
  const primaryDomain = document.getElementById("adminCoDomain").value.trim();
  const billingModel = document.getElementById("adminCoBillingModel")?.value === "service_based"
    ? "service_based"
    : "hourly";
  const fromEmails = document.getElementById("adminCoFrom").value
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  const result = await fetchAdmin("/api/admin/companies", {
    method: "POST",
    body: JSON.stringify({ slug, displayName, primaryDomain, fromEmails, billingModel }),
  });
  if (!result.ok) {
    adminSetStatus("adminCoStatus", result.data.error || "Failed to create company", true);
    return;
  }
  document.getElementById("adminCoSlug").value = "";
  document.getElementById("adminCoName").value = "";
  document.getElementById("adminCoDomain").value = "";
  document.getElementById("adminCoFrom").value = "";
  const billingModelSelect = document.getElementById("adminCoBillingModel");
  if (billingModelSelect) billingModelSelect.value = "hourly";
  adminSetStatus("adminCoStatus", "Company created");
  await adminLoadCompanies();
  await adminLoadUsers();
}

async function adminDeleteCompany(companyId) {
  if (!confirm("Delete this company?")) return;
  const result = await fetchAdmin("/api/admin/companies/delete", {
    method: "POST",
    body: JSON.stringify({ id: companyId }),
  });
  if (!result.ok) {
    alert(result.data.error || "Failed to delete company");
    return;
  }
  await adminLoadCompanies();
  await adminLoadUsers();
}

async function adminEditCompany(companyId) {
  const company = adminCompaniesCache.find((c) => c.id === companyId);
  if (!company) {
    alert("Company not found");
    return;
  }

  const sub = company.subscription || { plan: "trial", status: "trialing", amountUsd: 0 };
  const periodEndIso = sub.currentPeriodEnd
    ? new Date(sub.currentPeriodEnd).toISOString().slice(0, 10)
    : "";

  const planOpt = (v, label) =>
    `<option value="${v}"${sub.plan === v ? " selected" : ""}>${label}</option>`;
  const statusOpt = (v, label) =>
    `<option value="${v}"${sub.status === v ? " selected" : ""}>${label}</option>`;

  const dlg = document.createElement("dialog");
  dlg.className = "app-dialog";
  dlg.innerHTML = `
    <form method="dialog">
      <h3>Edit company</h3>

      <div class="form-group">
        <label>Display name</label>
        <input type="text" id="ec_name" value="${escapeHtml(company.displayName || "")}" />
      </div>
      <div class="form-group">
        <label>Primary domain</label>
        <input type="text" id="ec_domain" value="${escapeHtml(company.primaryDomain || "")}" placeholder="lhpest.com" />
      </div>
      <div class="form-group">
        <label>From emails (comma-separated)</label>
        <input type="text" id="ec_from" value="${escapeHtml((company.fromEmails || []).join(", "))}" />
      </div>
      <div class="form-group">
        <label>Billing model</label>
        <select id="ec_billing_model">
          <option value="hourly"${(company.billingModel === "service_based" ? "" : " selected")}>Hourly Billing</option>
          <option value="service_based"${(company.billingModel === "service_based" ? " selected" : "")}>Service-Based Billing</option>
        </select>
      </div>

      <hr style="margin:1rem 0; border:0; border-top:1px solid var(--border-color);" />
      <div style="font-weight:600; margin-bottom:0.5rem;">SaaS subscription (what they pay you)</div>

      <div style="display:flex; gap:0.5rem;">
        <div class="form-group" style="flex:1;">
          <label>Plan</label>
          <select id="ec_plan">
            ${planOpt("trial", "Trial")}
            ${planOpt("monthly", "Monthly")}
            ${planOpt("yearly", "Yearly")}
            ${planOpt("custom", "Custom")}
            ${planOpt("free", "Free / comp")}
          </select>
        </div>
        <div class="form-group" style="flex:1;">
          <label>Status</label>
          <select id="ec_status">
            ${statusOpt("trialing", "Trialing")}
            ${statusOpt("active", "Active")}
            ${statusOpt("past_due", "Past due")}
            ${statusOpt("canceled", "Canceled")}
          </select>
        </div>
      </div>
      <div style="display:flex; gap:0.5rem;">
        <div class="form-group" style="flex:1;">
          <label>Amount (USD per period)</label>
          <input type="number" id="ec_amount" min="0" step="0.01" value="${Number(sub.amountUsd || 0)}" />
        </div>
        <div class="form-group" style="flex:1;">
          <label>Current period ends</label>
          <input type="date" id="ec_period" value="${escapeHtml(periodEndIso)}" />
        </div>
      </div>
      <div class="form-group">
        <label>Notes (internal)</label>
        <input type="text" id="ec_notes" value="${escapeHtml(sub.notes || "")}" placeholder="e.g. discount applied, contract terms" />
      </div>

      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" id="ec_cancel">Cancel</button>
        <button type="button" class="btn" id="ec_save">Save</button>
      </div>
    </form>
  `;
  document.body.appendChild(dlg);
  dlg.showModal();

  const cleanup = () => { try { dlg.close(); } catch {} dlg.remove(); };
  dlg.querySelector("#ec_cancel").addEventListener("click", cleanup);
  dlg.querySelector("#ec_save").addEventListener("click", async () => {
    const periodVal = dlg.querySelector("#ec_period").value;
    const periodEnd = periodVal ? new Date(periodVal + "T00:00:00").getTime() : undefined;
    const subscription = {
      plan: dlg.querySelector("#ec_plan").value,
      status: dlg.querySelector("#ec_status").value,
      amountUsd: Number(dlg.querySelector("#ec_amount").value) || 0,
      currentPeriodEnd: periodEnd,
      startedAt: sub.startedAt || Date.now(),
      notes: dlg.querySelector("#ec_notes").value.trim() || undefined,
    };
    const result = await fetchAdmin("/api/admin/companies/update", {
      method: "POST",
      body: JSON.stringify({
        id: companyId,
        displayName: dlg.querySelector("#ec_name").value.trim(),
        primaryDomain: dlg.querySelector("#ec_domain").value.trim() || undefined,
        billingModel: dlg.querySelector("#ec_billing_model").value,
        fromEmails: dlg.querySelector("#ec_from").value
          .split(",").map((s) => s.trim()).filter(Boolean),
        subscription,
      }),
    });
    if (!result.ok) {
      alert(result.data.error || "Failed to update company");
      return;
    }
    cleanup();
    await adminLoadCompanies();
    await adminLoadUsers();
  });
}

async function adminAddUser() {
  adminSetStatus("adminUserStatus", "");
  const email = document.getElementById("adminUserEmail").value.trim();
  const password = document.getElementById("adminUserPassword").value;
  const role = document.getElementById("adminUserRole").value;
  const companyId = document.getElementById("adminUserCompany").value || undefined;
  const result = await fetchAdmin("/api/admin/users", {
    method: "POST",
    body: JSON.stringify({ email, password, role, companyId }),
  });
  if (!result.ok) {
    adminSetStatus("adminUserStatus", result.data.error || "Failed to create user", true);
    return;
  }
  document.getElementById("adminUserEmail").value = "";
  document.getElementById("adminUserPassword").value = "";
  adminSetStatus("adminUserStatus", "User created");
  await adminLoadUsers();
}

async function adminDeleteUser(userId) {
  if (!confirm("Delete this user?")) return;
  const result = await fetchAdmin("/api/admin/users/delete", {
    method: "POST",
    body: JSON.stringify({ userId }),
  });
  if (!result.ok) {
    alert(result.data.error || "Failed to delete user");
    return;
  }
  await adminLoadUsers();
}

async function adminEditUser(userId) {
  const usersResult = await fetchAdmin("/api/admin/users");
  if (!usersResult.ok) {
    alert(usersResult.data.error || "Failed to load users");
    return;
  }
  const user = (usersResult.data.users || []).find((u) => u.id === userId);
  if (!user) {
    alert("User not found");
    return;
  }

  // Platform-admin can assign that role; everyone else is limited to member/admin/owner.
  const isPlatform = isPlatformAdminRole();
  const roleOptions = isPlatform
    ? ["member", "admin", "owner", "platform-admin"]
    : ["member", "admin", "owner"];

  const dlg = document.createElement("dialog");
  dlg.className = "app-dialog";
  const companyOptions = `<option value="">(no company)</option>` + adminCompaniesCache
    .map((c) => `<option value="${escapeHtml(c.id)}"${c.id === user.companyId ? " selected" : ""}>${escapeHtml(c.displayName)}</option>`)
    .join("");
  const roleSelect = roleOptions
    .map((r) => `<option value="${r}"${r === user.role ? " selected" : ""}>${r}</option>`)
    .join("");
  dlg.innerHTML = `
    <form method="dialog" id="editUserForm">
      <h3>Edit user</h3>
      <div class="small-text" style="margin-bottom:0.75rem;">${escapeHtml(user.email)}</div>
      <div class="form-group">
        <label>Role</label>
        <select id="editUserRole">${roleSelect}</select>
      </div>
      <div class="form-group" style="margin-bottom:1rem;">
        <label>Company</label>
        <select id="editUserCompany">${companyOptions}</select>
      </div>
      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" id="editUserCancel">Cancel</button>
        <button type="button" class="btn" id="editUserSave">Save</button>
      </div>
    </form>
  `;
  document.body.appendChild(dlg);
  dlg.showModal();

  const cleanup = () => { try { dlg.close(); } catch {} dlg.remove(); };
  dlg.querySelector("#editUserCancel").addEventListener("click", cleanup);
  dlg.querySelector("#editUserSave").addEventListener("click", async () => {
    const role = dlg.querySelector("#editUserRole").value;
    const companyVal = dlg.querySelector("#editUserCompany").value;
    const result = await fetchAdmin("/api/admin/users/update", {
      method: "POST",
      body: JSON.stringify({
        userId,
        role,
        companyId: companyVal ? companyVal : null,
      }),
    });
    if (!result.ok) {
      alert(result.data.error || "Failed to update user");
      return;
    }
    cleanup();
    await adminLoadUsers();
  });
}

async function adminToggleDisable(userId, disabled) {
  const result = await fetchAdmin("/api/admin/users/update", {
    method: "POST",
    body: JSON.stringify({ userId, disabled }),
  });
  if (!result.ok) {
    alert(result.data.error || "Failed to update user");
    return;
  }
  await adminLoadUsers();
}

async function adminRemoveCompany(userId) {
  const result = await fetchAdmin("/api/admin/users/update", {
    method: "POST",
    body: JSON.stringify({ userId, companyId: null }),
  });
  if (!result.ok) {
    alert(result.data.error || "Failed to update user");
    return;
  }
  await adminLoadUsers();
}

async function adminResetPassword(email) {
  const password = prompt(`New password for ${email}:`);
  if (!password) return;
  const result = await fetchAdmin("/api/admin/users/password", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
  if (!result.ok) {
    alert(result.data.error || "Failed to reset password");
    return;
  }
  alert("Password reset.");
}

async function adminBillingStartCheckout(companyId) {
  const company = adminCompaniesCache.find((c) => c.id === companyId);
  if (!company) return;

  const dlg = document.createElement("dialog");
  dlg.className = "app-dialog";
  dlg.innerHTML = `
    <form method="dialog">
      <h3>Send plan invoice</h3>
      <div class="small-text" style="margin-bottom:0.75rem;">${escapeHtml(company.displayName)}${company.platformBillingEmail ? ` · ${escapeHtml(company.platformBillingEmail)}` : ""}</div>
      <div class="form-group">
        <label>Plan</label>
        <select id="bc_plan">
          <option value="solo">Solo — $29/mo</option>
          <option value="pro">Pro — $69/mo</option>
          <option value="team">Team — $149/mo</option>
        </select>
      </div>
      <div class="form-group">
        <label>Billing cycle</label>
        <select id="bc_cycle">
          <option value="monthly">Monthly</option>
          <option value="yearly">Yearly</option>
        </select>
      </div>
      <div class="form-group">
        <label>Billing email</label>
        <input type="email" id="bc_email" value="${escapeHtml(company.platformBillingEmail || (company.fromEmails || [])[0] || "")}" placeholder="client@example.com" />
      </div>
      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" id="bc_cancel">Cancel</button>
        <button type="button" class="btn" id="bc_start">Send invoice</button>
      </div>
    </form>
  `;
  document.body.appendChild(dlg);
  dlg.showModal();

  const cleanup = () => { try { dlg.close(); } catch {} dlg.remove(); };
  dlg.querySelector("#bc_cancel").addEventListener("click", cleanup);
  dlg.querySelector("#bc_start").addEventListener("click", async () => {
    const planId = dlg.querySelector("#bc_plan").value;
    const billingCycle = dlg.querySelector("#bc_cycle").value;
    const billingEmail = dlg.querySelector("#bc_email").value.trim();
    if (!billingEmail) { alert("Billing email is required"); return; }
    dlg.querySelector("#bc_start").disabled = true;
    dlg.querySelector("#bc_start").textContent = "Sending…";
    const result = await fetchAdmin("/api/admin/billing/checkout-session", {
      method: "POST",
      body: JSON.stringify({ companyId, planId, billingCycle, billingEmail }),
    });
    if (!result.ok) {
      alert(result.data.error || "Failed to create subscription");
      dlg.querySelector("#bc_start").disabled = false;
      dlg.querySelector("#bc_start").textContent = "Send invoice";
      return;
    }
    cleanup();
    alert(result.data.message || `Invoice queued for ${billingEmail}`);
    await adminLoadCompanies();
  });
}

async function adminBillingPortal(companyId) {
  const result = await fetchAdmin("/api/admin/billing/portal-session", {
    method: "POST",
    body: JSON.stringify({
      companyId,
      returnUrl: window.location.origin + "/",
    }),
  });
  if (!result.ok) {
    alert(result.data.error || "Failed to open billing portal");
    return;
  }
  window.open(result.data.portalUrl, "_blank");
}

async function adminBillingAddCustomService(companyId) {
  const company = adminCompaniesCache.find((c) => c.id === companyId);
  if (!company) return;

  const dlg = document.createElement("dialog");
  dlg.className = "app-dialog";
  dlg.innerHTML = `
    <form method="dialog">
      <h3>Add custom service</h3>
      <div class="small-text" style="margin-bottom:0.75rem;">${escapeHtml(company.displayName)}</div>
      <div class="form-group">
        <label>Service name</label>
        <input type="text" id="cs_name" placeholder="e.g. Website Redesign" />
      </div>
      <div class="form-group">
        <label>Amount (USD)</label>
        <input type="number" id="cs_amount" min="1" step="0.01" placeholder="500" />
      </div>
      <div class="form-group">
        <label>Billing type</label>
        <select id="cs_interval">
          <option value="one_time">One-time</option>
          <option value="monthly">Monthly recurring</option>
        </select>
      </div>
      <div class="form-group">
        <label>Notes (internal, optional)</label>
        <input type="text" id="cs_notes" placeholder="e.g. Phase 1 of redesign project" />
      </div>
      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" id="cs_cancel">Cancel</button>
        <button type="button" class="btn" id="cs_add">Add service</button>
      </div>
    </form>
  `;
  document.body.appendChild(dlg);
  dlg.showModal();

  const cleanup = () => { try { dlg.close(); } catch {} dlg.remove(); };
  dlg.querySelector("#cs_cancel").addEventListener("click", cleanup);
  dlg.querySelector("#cs_add").addEventListener("click", async () => {
    const name = dlg.querySelector("#cs_name").value.trim();
    const amountUsd = Number(dlg.querySelector("#cs_amount").value);
    const interval = dlg.querySelector("#cs_interval").value;
    const notes = dlg.querySelector("#cs_notes").value.trim() || undefined;
    if (!name) { alert("Service name is required"); return; }
    if (!amountUsd || amountUsd <= 0) { alert("Amount must be greater than 0"); return; }
    const result = await fetchAdmin("/api/admin/billing/custom-service", {
      method: "POST",
      body: JSON.stringify({ companyId, name, amountUsd, interval, notes }),
    });
    if (!result.ok) {
      alert(result.data.error || "Failed to add custom service");
      return;
    }
    cleanup();
    alert(result.data.message || "Custom service added.");
    await adminLoadCompanies();
  });
}
